import React from 'react';
import {withRouter, Switch, Route, Link} from 'react-router-dom';
import Cookies from "universal-cookie";
import '../styles/cookie-consent.css';

const cookies = new Cookies();

class CookiesNotification extends React.Component {
    constructor(props) {
        super(props);
        this.handler = this.handler.bind(this);
        this.state = {showNotification: false};
    }

    componentDidMount(){
        if(!cookies.get('cookiesAccepted')){
            this.setState({
                showNotification: true
            });
        }
    }

    handler() {
        cookies.set('cookiesAccepted', true, { path: '/' });
        this.setState({
            showNotification: false
        })
    }

    render() {
        if(!this.state.showNotification){
            return null;
        }
        return (
            <div className={this.state.showNotification ? 'cookies-bar active' : 'cookies-bar'}>
                <div className="container">
                    <div className="copy">
                        {this.props.lang === 'en'
                        ?
                            <p>This website uses cookies to ensure you get the best experience on our website. <br />Please read our <a href="/en-privacy-policy">Privacy Policy</a> for more information.</p>
                        :
                            <p>Ova stranica koristi kolačiće. <a href="/privacy-policy">Detalji</a></p>
                        }
                    </div>
                    <nav>
                        <button type="button" className="button small-btn" onClick={this.handler}><span>{this.props.lang === 'en' ? 'Accept' : 'Prihvatam'}</span></button>
                    </nav>
                </div>
            </div>
        );
    }
}

export default CookiesNotification;


// WEBPACK FOOTER //
// ./src/components/CookiesNotification.js